import * as types from "../constants/actionTypes";
import initialstate from "./initialState";

export default (state = initialstate.globalNotification, action) => {
  switch (action.type) {
    case types.SHOW_GLOBAL_NOTIFICATION:
      return action.payload;
    case types.HIDE_GLOBAL_NOTIFICATION:
      return {
        show: false,
        msg: ""
      };
    case types.ADDON_ADDED:
      return {
        show: true,
        msg: action.payload.msg
      };
    case types.CLUB_USER_LOGIN:
      if (action.msg) {
        return {
          show: true,
          msg: action.msg,
          type: "success"
        };
      } else {
        return state;
      }
    case types.CLUB_USER_LOGIN_FAILED:
      return {
        show: true,
        msg: action.msg,
        type: "error"
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/globalNotificationReducer.js